var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _g2, _path21, _rect, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 800.52997,
    height: 669.89403,
    viewBox: "0 0 800.52997 669.89403",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f3ece1e0-ef03-419f-b8e8-18bd41cf5781-445",
    "data-name": "Path 663",
    d: "M613.735,273.974h-3.674V173.313a58.26,58.26,0,0,0-58.26-58.26H338.537a58.26,58.26,0,0,0-58.26,58.26h0V725.547a58.26,58.26,0,0,0,58.26,58.26H551.801a58.26,58.26,0,0,0,58.26-58.26h0V345.626h3.674Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e480e001-9f57-4dea-b53d-7fffcfd996e5-446",
    "data-name": "Path 664",
    d: "M554.152,130.21H526.313a20.671,20.671,0,0,1-19.138,28.477H384.999a20.67,20.67,0,0,1-19.136-28.477h-26a43.508,43.508,0,0,0-43.508,43.508V725.144a43.508,43.508,0,0,0,43.508,43.506H554.152a43.508,43.508,0,0,0,43.511-43.505v-.001h0V173.718a43.508,43.508,0,0,0-43.508-43.508Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ba49744f-f082-4b9b-8fe0-04dfc5c87207-447",
    "data-name": "Path 667",
    d: "M576.92,537.873H316.987a4.819,4.819,0,0,1-4.814-4.814V413.707a4.819,4.819,0,0,1,4.814-4.814H576.92a4.819,4.819,0,0,1,4.814,4.814V533.06A4.819,4.819,0,0,1,576.92,537.873ZM316.987,410.819a2.891,2.891,0,0,0-2.888,2.888V533.06a2.891,2.891,0,0,0,2.888,2.888H576.92a2.891,2.891,0,0,0,2.888-2.888V413.707a2.891,2.891,0,0,0-2.888-2.888Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a7dd5626-229a-40eb-a33d-aa1cc336dbcf-448",
    "data-name": "Path 668",
    d: "M574.991,382.877H459.469a4.819,4.819,0,0,1-4.814-4.814V313.584a4.819,4.819,0,0,1,4.814-4.814H574.991a4.819,4.819,0,0,1,4.814,4.814v64.478A4.819,4.819,0,0,1,574.991,382.877Zm-115.526-72.18a2.891,2.891,0,0,0-2.888,2.888v64.478a2.891,2.891,0,0,0,2.888,2.888H574.991a2.891,2.891,0,0,0,2.888-2.888V313.584a2.891,2.891,0,0,0-2.888-2.888Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "a16314f7-f00c-4976-916e-e84ba52f898d-449",
    "data-name": "Path 669",
    d: "M432.513,693.832H316.987a4.819,4.819,0,0,1-4.814-4.814V568.703a4.819,4.819,0,0,1,4.814-4.813H432.513a4.819,4.819,0,0,1,4.814,4.813V689.019a4.819,4.819,0,0,1-4.814,4.814ZM316.987,565.815a2.891,2.891,0,0,0-2.888,2.888V689.019a2.891,2.891,0,0,0,2.888,2.888H432.513a2.891,2.891,0,0,0,2.888-2.888V568.703a2.891,2.891,0,0,0-2.888-2.888Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "ff458f63-8b5f-47e8-b083-2ad22e87cfd3-450",
    "data-name": "Path 670",
    d: "M574.991,693.832H459.469a4.819,4.819,0,0,1-4.814-4.814V568.703a4.819,4.819,0,0,1,4.814-4.813H574.991a4.819,4.819,0,0,1,4.814,4.814V689.019a4.819,4.819,0,0,1-4.814,4.814ZM459.469,565.815a2.891,2.891,0,0,0-2.888,2.888V689.019a2.891,2.891,0,0,0,2.888,2.888H574.991a2.891,2.891,0,0,0,2.888-2.888V568.703a2.891,2.891,0,0,0-2.888-2.888Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "efd36987-4445-4d6c-a721-ed725b3ae6b1",
    "data-name": "Group 37"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "ae80ce67-d658-4942-93d1-f9f8c2502a32-451",
    "data-name": "Path 703",
    d: "M789.96969,776.55959l-175.745-175.745c-4.04251-4.04251-5.79332-8.84237-3.91878-10.72679l45.59354-45.59354c1.88373-1.87386,6.68146-.12091,10.7268,3.91878l175.7443,175.7443c4.04182,4.04182,5.79332,8.84237,3.9188,10.72682l-45.59283,45.59282C798.81133,782.35217,794.01365,780.59928,789.96969,776.55959Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a536dc17-fdb9-4c75-a356-ceb06d58c2db",
    "data-name": "Ellipse 88",
    cx: 466.19543,
    cy: 485.06649,
    r: 20.571,
    fill: "#f4323c",
    opacity: 0.997,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "f2dd04dc-09c3-4238-ac75-54c3277f7a5e-452",
    "data-name": "Path 703",
    d: "M789.96969,776.55959l-175.745-175.745c-4.04251-4.04251-5.79332-8.84237-3.91878-10.72679l45.59354-45.59354c1.88373-1.87386,6.68146-.12091,10.7268,3.91878l175.7443,175.7443c4.04182,4.04182,5.79332,8.84237,3.9188,10.72682l-45.59283,45.59282C798.81133,782.35217,794.01365,780.59928,789.96969,776.55959Zm-124.70606-226.784c-2.42537-2.42537-5.30615-3.47615-6.43607-2.35183l-45.59283,45.59283c-1.12713,1.12712-.07281,4.00859,2.35183,6.43608L791.33086,775.197c2.42537,2.42537,5.30615,3.47615,6.43608,2.35183l45.59351-45.59352c1.12713-1.12713.07281-4.00859-2.35182-6.43608Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "bee22ee7-13f1-45a2-8f8b-e029916d096c-453",
    "data-name": "Path 705",
    d: "M703.26356,618.966a3.268,3.268,0,0,0-4.62166,4.62166L809.0361,733.98183a3.268,3.268,0,0,0,4.62165-4.62165Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#f4323c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "be4d3839-d4d1-4f21-bbff-0cb80c648cd9-454",
    "data-name": "Path 706",
    d: "M689.3986,632.83094a3.268,3.268,0,1,0-4.62166,4.62166l110.3942,110.39419a3.268,3.268,0,0,0,4.62165-4.62165Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#f4323c"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "abaeedc8-d03c-4b96-8b61-dc05a7eae213-455",
    "data-name": "Path 677",
    d: "M432.411,382.889H324.038l25.5-44.175a5.208,5.208,0,0,1,9.021,0l10.895,18.871,18.528-32.089a6.52,6.52,0,0,1,11.294,0Zm-105.039-1.925h101.7l-31.468-54.5a4.594,4.594,0,0,0-7.958,0l-20.189,34.972-12.563-21.759a3.282,3.282,0,0,0-5.685,0Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "b22cd124-c328-4932-b3c3-ba3965d6dab6-456",
    "data-name": "Path 678",
    d: "M571.042,382.889H462.669l25.5-44.175a5.208,5.208,0,0,1,9.021,0l10.894,18.871,18.529-32.089a6.52,6.52,0,0,1,11.294,0Zm-105.039-1.925h101.7l-31.468-54.5a4.594,4.594,0,0,0-7.958,0L508.084,361.436l-12.563-21.759a3.282,3.282,0,0,0-5.685,0Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "b550759e-d036-41c8-9300-04702c07481c-457",
    "data-name": "Path 679",
    d: "M432.513,382.877H316.987a4.819,4.819,0,0,1-4.814-4.814V313.584a4.819,4.819,0,0,1,4.814-4.814H432.513a4.819,4.819,0,0,1,4.814,4.814v64.478a4.819,4.819,0,0,1-4.814,4.814Zm-115.526-72.18a2.891,2.891,0,0,0-2.888,2.888v64.478a2.891,2.891,0,0,0,2.888,2.888H432.513a2.891,2.891,0,0,0,2.888-2.888V313.584a2.891,2.891,0,0,0-2.888-2.888Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "a463ccbc-2a3f-4db8-a48a-3e1bf6d17a5c-458",
    "data-name": "Path 680",
    d: "M341.604,588.702a3.268,3.268,0,1,0,0,6.536h66.293a3.268,3.268,0,0,0,0-6.536Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "a58e7c76-5590-426a-8c04-70a53a50dbe0-459",
    "data-name": "Path 681",
    d: "M341.604,607.956a3.268,3.268,0,1,0,0,6.536h66.293a3.268,3.268,0,0,0,0-6.536Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "a7930865-63b0-4d5a-bc4b-67c15fb4df22-460",
    "data-name": "Path 682",
    d: "M374.751,669.02a20.57,20.57,0,1,1,20.57-20.571h0A20.594,20.594,0,0,1,374.751,669.02Zm0-39.216a18.645,18.645,0,1,0,18.645,18.645h0a18.667,18.667,0,0,0-18.645-18.643Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "ad955a95-e121-4780-a74e-b432a3252564-461",
    "data-name": "Path 683",
    d: "M550.382,669.022a3.268,3.268,0,1,0,0-6.536h-66.3a3.268,3.268,0,0,0,0,6.536Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "a7c66777-abee-4d81-bb93-449ee7f11fb0-462",
    "data-name": "Path 684",
    d: "M550.382,649.766a3.268,3.268,0,1,0,0-6.536h-66.3a3.268,3.268,0,0,0,0,6.536Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b7b1963f-580a-432b-accc-2d0244cec1c5",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ef92db75-82b1-4bdc-bb35-3743c646513c-463",
    "data-name": "Path 686",
    d: "M880.269,768.898H864.082l-7.7-62.434h23.89Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be98cec8-ca71-46b0-afdd-2a884d94ea8b-464",
    "data-name": "Path 687",
    d: "M847.752,764.272h35.985v19.655H832.865v-4.768A14.887,14.887,0,0,1,847.752,764.272Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "abfee3c5-ff11-48c7-921c-6c90de4fadef-465",
    "data-name": "Path 688",
    d: "M944.963,768.898H928.777l-7.7-62.434h23.89Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fd19061e-e10a-4611-97bb-4a155c9edfee-466",
    "data-name": "Path 689",
    d: "M912.447,764.272H948.432v19.655H897.56v-4.768A14.887,14.887,0,0,1,912.447,764.272Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a70ff991-d3b0-4688-a8cf-70f68c9b4702-467",
    "data-name": "Path 690",
    d: "M852.068,588.915a12.38006,12.38006,0,0,0-1.067-18.954l6.935-27.428-15.64-8.279-9.249,38.871a12.447,12.447,0,0,0,19.022,15.79Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a858fd09-61d6-4242-9d67-7403c8362434-468",
    "data-name": "Path 691",
    d: "M950.72,541.008l-1.32,92.421-1.318,121.467-29.046-2.641L904.51,584.578,886.026,752.255H856.038l-3.02-169,10.564-36.966Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eb821483-141e-4d8c-b2c3-be9c70c9f779-469",
    "data-name": "Path 692",
    d: "M860.682,546.853l-.425-.192,16.554-113.227-8.416-34.223a7.49,7.49,0,0,1,4.642-8.8l15.142-5.678,5.349-14.711,42.206,4.548,1.038,11.5c4.574,1.467,42.237,14.01,39.638,28.3-2.565,14.107-17.709,58.489-18.478,60.738l-2.65009,63.65-.326.163c-.393.2-29.484,14.5-61.089,14.5C882.74,553.418,871.292,551.643,860.682,546.853Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa45b358-6308-4c73-8d1d-00728ecfcc3a-470",
    "data-name": "Path 693",
    d: "M832.499,558.738l13.306-85.162c.079-.5,7.952-50.355,10.563-66.02,2.7-16.173,15.216-16.36,15.342-16.36h6.89l8.059,36.265-15.877,72.764-14.647,60.3Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7fe92b4-de1b-4200-a6c6-8b9f915710d4-471",
    "data-name": "Path 694",
    d: "M918.811,550.333a12.38091,12.38091,0,0,1,15.115-11.486l16.372-23.073,16.448,6.529-23.578,32.258a12.447,12.447,0,0,1-24.357-4.23Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac6373f4-3eaa-40bf-871f-e19bddead59b-472",
    "data-name": "Path 695",
    d: "M936.771,530.491l29.111-48.957-11.86-31.625,16.152-43.074.6.256c.391.167,9.568,4.263,10.929,18.93l18.562,58.337-49.539,64.267Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b6d36705-587c-43da-a8ac-ac3efa3ab058",
    "data-name": "Ellipse 109",
    cx: 713.2443,
    cy: 217.30428,
    r: 30.389,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fae5a11b-ad0d-4fa1-abec-f604f1b46735-473",
    "data-name": "Path 696",
    d: "M892.582,317.552c3.146,3.723,8.469,4.773,13.38,5.2,9.974.875,24.476-.544,34.223-2.794.7,6.742-1.2,14.012,2.77,19.559a90.80264,90.80264,0,0,0,3.226-20.584c.12-2.986.073-6.075-1.14-8.816s-3.86-5.068-6.907-5.092a17.31078,17.31078,0,0,1,7.722-3.3l-9.649-4.849,2.478-2.544-17.469-1.069,5.06-3.214a109.71715,109.71715,0,0,0-22.99408-.723c-3.56.262-7.282.763-10.166,2.826s-4.551,6.162-2.76,9.19a13.344,13.344,0,0,0-10.169,8.069c-1.286,3.26-1.168,6.881-.772,10.355a73.3936,73.3936,0,0,0,3.848,16.281",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#2f2e41"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "a57d06b9-a264-4f30-acb6-9c7bb9fd2b38-474",
    "data-name": "Path 138",
    d: "M892.583,783.833H662.758c-2.349-.006-4.253-3.9-4.256-8.708V658.476c0-4.807,1.907-8.7,4.256-8.708H892.583c2.349.006,4.253,3.9,4.256,8.708V775.124C896.836,779.931,894.929,783.827,892.583,783.833Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "bed4592e-bfef-4948-be3e-766185c26c32-475",
    "data-name": "Path 685",
    d: "M517.232,588.702a20.57,20.57,0,1,1-20.57,20.57h0A20.594,20.594,0,0,1,517.232,588.702Zm0,39.215A18.645,18.645,0,1,0,498.584,609.272h0a18.66694,18.66694,0,0,0,18.645,18.645Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b41831fc-8682-4293-a816-c92845d33ebe",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "e81e8c09-618a-4d75-9221-ad232d9ca9f3",
    "data-name": "Ellipse 7",
    cx: 536.93501,
    cy: 580.89899,
    r: 20.097,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd6b3e8c-0c0b-49d3-8133-5cdbff8e6f79-476",
    "data-name": "Path 63",
    d: "M799.692,757.882H701.103a2.01823,2.01823,0,0,1-.368-.03l46.63-80.765a3.264,3.264,0,0,1,5.683,0l31.293,54.2,1.5,2.593Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#f4323c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9e2e983-e357-480b-a57b-d6d593ec34af-477",
    "data-name": "Path 65",
    d: "M854.583,757.883H769.311l16.523-24,1.189-1.729,21.532-31.278a4.357,4.357,0,0,1,6.472-.386,3.89169,3.89169,0,0,1,.31.386Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#f4323c"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "a5f9a565-7299-4148-94cd-c120a27c3e96-478",
    "data-name": "Path 138",
    d: "M892.583,783.833H662.758c-2.349-.006-4.253-3.9-4.256-8.708V658.476c0-4.807,1.907-8.7,4.256-8.708H892.583c2.349.006,4.253,3.9,4.256,8.708V775.124C896.836,779.931,894.929,783.827,892.583,783.833ZM662.758,653.251c-1.41,0-2.552,2.341-2.554,5.225V775.124c0,2.884,1.144,5.222,2.554,5.225H892.583c1.41,0,2.552-2.34,2.554-5.225V658.476c0-2.884-1.144-5.222-2.554-5.225Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ba18eddc-2455-49ce-9095-2cb6214fb14a",
    "data-name": "Rectangle 110",
    y: 667.89403,
    width: 782,
    height: 2,
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "e74167c2-7c00-4cc6-a1ea-9e2f8afaeadf-479",
    "data-name": "Path 734",
    d: "M576.92,282.755H316.987c-2.657,0-4.81-1.239-4.814-2.766V211.415c0-1.527,2.156-2.764,4.814-2.766H576.92c2.657,0,4.81,1.239,4.814,2.766V279.99C581.731,281.516,579.577,282.753,576.92,282.755Zm-259.933-73c-1.594,0-2.886.743-2.888,1.659v68.575c0,.916,1.294,1.658,2.888,1.659H576.92c1.594,0,2.886-.743,2.888-1.659V211.415c0-.916-1.294-1.658-2.888-1.659Z",
    transform: "translate(-199.73501 -115.05299)",
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWhatsapp);
export default __webpack_public_path__ + "static/media/noWhatsapp.80f78d1cbdcd307eb12b26b2fe771b95.svg";
export { ForwardRef as ReactComponent };